import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import StyledPopup from './StyledPopup';
import StyledPopupOption from './StyledPopupOption';
import MarkerContext from '../../contexts/MarkerContext';

function Popup({ text, options }) {
	const context = useContext(MarkerContext);
	const openPopup = context ? context.openPopup : () => {};
	const closePopup = () => openPopup(null);

	return (
		<StyledPopup>
			<p>{text}</p>
			<ul>
				{options.map(option => (
					<StyledPopupOption key={`styled-popup-${option.label}`} onClick={closePopup}>
						<a href={option.uri} target="_blank" rel="noopener noreferrer">
							{option.label}
						</a>
					</StyledPopupOption>
				))}
				<StyledPopupOption onClick={closePopup}>
					<button type="button">Abbrechen</button>
				</StyledPopupOption>
			</ul>
		</StyledPopup>
	);
}

Popup.propTypes = {
	text: PropTypes.string,
	options: PropTypes.array,
};

Popup.defaultProps = {
	text: '',
	options: [],
};

export default Popup;
